const constants = {
	facebook: {
		appId: '445102699541661'
	}
};

export default constants;
